import React, { useState } from 'react';
import './FormStyle.css';
import axios from 'axios';

const Form = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value});
  };


  const [successMessage, setSuccessMessage] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('http://localhost:5000/send-email', formData);
      setSuccessMessage("המייל נשלח בהצלחה!");
      setFormData({ name: '', email: '', subject: '',phone: '', message: '' }); // לאפס טופס אם רוצים
      
      setTimeout(() => {
      window.location.reload();
      }, 3000);

    } catch (err) {
      setSuccessMessage("שגיאה בשליחה. נסה שוב.");
    }
  };


  return (
    <div className="form">
      <form onSubmit={handleSubmit}>
        <label>שם</label>
        <input type="text" name="name" onChange={handleChange} required />

        <label>מייל</label>
        <input type="email" name="email" onChange={handleChange} required />

        <label>נושא</label>
        <input type="text" name="subject" onChange={handleChange} required />

        <label>טלפון לחזרה</label>
        <input type="text" name="phone" onChange={handleChange} required />

        <label>מלל חופשי</label>
        <textarea name="message" rows="6" onChange={handleChange} required />

        <button className="btn" type="submit">שלח</button>

        {successMessage && <p className="success">{successMessage}</p>}

      </form>
    </div>
  );
};

export default Form;
